import { useState } from 'react'

import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import { DialogPltKSConfirmation } from 'app/KinerjaPage/components/DialogPltKSConfirmation'
import { CardKSSchool } from 'app/KinerjaShared/components/CardKSSchool'

import type { PelaksanaanSchool } from 'types/kinerja-pelaksanaan'

interface DialogSelectSchoolPerencanaanProps
  extends Omit<DialogProps, 'children'> {
  schools: PelaksanaanSchool[]
  baseUrl?: string
}

export function DialogSelectSchoolPerencanaan({
  isOpen,
  onClose,
  schools,
  baseUrl = PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
}: DialogSelectSchoolPerencanaanProps) {
  const [showDialogPltConfirmation, setShowDialogPltConfirmation] =
    useState(false)

  const handleShowDialogPltConfirmation = () => {
    setShowDialogPltConfirmation(true)
  }

  return (
    <>
      <Dialog
        isOpen={isOpen}
        onClose={onClose}
        customSize={484}
        autoFocus={false}
      >
        <DialogOverlay />
        <DialogContent className="p-6 m-auto self-center">
          <div className="flex justify-between items-center">
            <Text variant="heading-md">Pilih satuan pendidikan</Text>
            <Button
              color="white"
              iconOnly
              size="sm"
              variant="ghost"
              className="!outline-none"
              onClick={() => onClose()}
            >
              <Icon color="inherit" fontSize="lg">
                close
              </Icon>
            </Button>
          </div>
          <div className="flex flex-col mt-6 gap-4">
            {schools
              .filter((school) => school.perencanaanReadyState != 'COMPLETED')
              .map((school) => {
                const nextPath = `${baseUrl}/periksa/${school.npsn}`

                return (
                  <CardKSSchool
                    key={school.npsn}
                    nextText="Periksa"
                    nextPath={nextPath}
                    confirmationPath={
                      school.statusSatuanPendidikan === 'SWASTA'
                        ? `${baseUrl}/konfirmasi-swasta/${school.npsn}?successPath=${nextPath}`
                        : undefined
                    }
                    onConfirmClick={
                      school.statusSatuanPendidikan === 'NEGERI'
                        ? handleShowDialogPltConfirmation
                        : undefined
                    }
                    confirmationStatus={school.confirmationStatus}
                    schoolName={school.schoolName}
                    schoolStatus={school.statusSatuanPendidikan}
                    schoolRole={school.role}
                    npsn={school.npsn}
                  />
                )
              })}
          </div>
        </DialogContent>
      </Dialog>

      <DialogPltKSConfirmation
        isOpen={showDialogPltConfirmation}
        onClose={() => setShowDialogPltConfirmation(false)}
      />
    </>
  )
}
